const transition = {
    duration: {
        normal: ".15s",
    },
};
export default transition;
//# sourceMappingURL=transition.js.map